import { render, staticRenderFns } from "./MyMemberDetails.vue?vue&type=template&id=8a13616e&scoped=true"
import script from "./MyMemberDetails.vue?vue&type=script&lang=js"
export * from "./MyMemberDetails.vue?vue&type=script&lang=js"
import style0 from "./MyMemberDetails.vue?vue&type=style&index=0&id=8a13616e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a13616e",
  null
  
)

export default component.exports